import React from 'react';

// Define a mapping for icons
export const iconMapping = {
    positions: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/etfMatrix.png',
    smalab: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/sma-lab.png',
    blacklist: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/blacklist-checkmark.png',
    screener: 'https://storage.googleapis.com/finiat-web-static-resources/app-icons/screens.jpg',
    formBuilder: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/align-360-app-icon.png',
    portfolios: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/new-portfolio-delta.png',
    performanceComparison: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/blacklist-checkmark.png',
    signals: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/signals-app-icon.png',
    portfolioBuilder: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/build.png',
    settings: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/settings.png',
    prospects: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/prospects.png',
    superUser: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/super-user-alt-1.png',
    files: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/files-alt-1.png',
    touchpoints: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/pulsa-app-icon.png',
    iq: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/iq-icon-2.png',
    resources: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/learning-app-icon.png'
};



// Define all available apps in one common array
export const allApps = [
    { label: 'Portfolios', iconUrl: iconMapping.portfolios, key: 'portfolios', path: '/portfolios' },
    { label: 'Signals', iconUrl: iconMapping.signals, key: 'signals', path: '/signals' },

    { label: 'ETF Matrix', iconUrl: iconMapping.positions, key: 'positions', path: '/etfs/matrix' },
    { label: 'Comparison', iconUrl: iconMapping.performanceComparison, key: 'performanceComparison', path: '/performance/comparison' },

    { label: 'Screener', iconUrl: iconMapping.screener, key: 'screener', path: '/screener' },
    { label: 'Blacklist', iconUrl: iconMapping.blacklist, key: 'blacklist', path: '/widgets/blacklist' },

    { label: 'Builder', iconUrl: iconMapping.portfolioBuilder, key: 'portfolioBuilder', path: '/builders/landing' },
    { label: 'Strata SMA', iconUrl: iconMapping.smalab, key: 'smalab', path: '/builders/sma' },
    { label: 'Align 360', iconUrl: iconMapping.formBuilder, key: 'formBuilder', path: '/builders/model' },


    {label: "SuperUser", iconUrl: iconMapping.superUser, key: 'superuser', path: '/superuser'}
];

export const appCategories = {
    adjust: ['signals', 'portfolios'],
    explain: ['positions', 'performanceComparison', 'screener'],
    customize: ['smalab', 'formBuilder', 'portfolioBuilder'],
    admin: ['superuser']
}


export const filterUserAppsIntoCategories = (userAppKeys) =>
  Object.entries(allApps.filter(app => userAppKeys.includes(app.key)).reduce((acc, app) => {
    for (let category in appCategories) {
      if (appCategories[category].includes(app.key)) acc[category].push(app);
    }
    return acc;
  }, {  adjust: [], explain: [],  customize: [], admin: [] })).map(([key, value]) => ({ key, value }));

// Function to filter apps based on user's keys
export const filterAppsForUser = (userAppKeys, prefix='') => {
    let filteredApps = allApps.filter(app => userAppKeys.includes(app.key));
    // filteredApps.sort((a, b) => userAppKeys.indexOf(a.key) - userAppKeys.indexOf(b.key));

    return [
        ...filteredApps
    ].map(x=>({...x, path: prefix+x.path}
    ));
};
